module.exports = __webpack_public_path__ + "img/bin.f8688607.svg";